<nav class="navbar navbar--central fixed-top" style="top: 0px;">
  <!-- Logo in nav bar -->
  <div class="container-fluid">
    <div class="navbar-search navbar-search--results is-active is-expanded" id="global-search">
      <div class="autocomplete__wrap autocomplete__wrap--search">
        <div class="form-control__wrap has-search has-clear has-filters">
          <div class="easy-autocomplete"><input type="text" [value]="search_query" placeholder="Search" id="global-search-input" class="form-control form-control--search autocomplete" autocomplete="off"><div class="easy-autocomplete-container" id="eac-container-global-search-input"><ul></ul></div></div>
          <span class="form-control__back" id="global-search-back">
            <svg class="icon">
              <use xlink:href="#chevron-left-small"></use>
            </svg>
          </span>
          <span class="form-control__search">
            <svg class="icon">
              <use xlink:href="#search"></use>
            </svg>
          </span>
          <a href="#" id="global-search-clear" class="form-control__clear form-control__clear--text is-active">Clear</a>
          <!-- <a href="#advanced-search-modal" data-toggle="modal" data-modal-type="static" id="global-search-advanced" class="form-control__filters">
            <svg class="icon icon--sm">
              <use xlink:href="#filter"></use>
            </svg>
          </a> -->
        </div>
      </div>
    </div>
    <div class="navbar-actions">
      <a href="#global-search" class="navbar-actions__search-mobile" id="global-search-trigger">
        <svg class="icon">
          <use xlink:href="#search"></use>
        </svg>
      </a>
      <a href="javascript:;" [routerLink]="'/'+documentPageRoute" class="navbar__close">
        <svg class="icon">
          <use xlink:href="#close-medium"></use>
        </svg>
      </a>
    </div>
  </div>
</nav>
<main class="page-main">
  <div class="layout layout--central">
    <div class="layout__row">
      <div class="layout__bodycol">
        <header class="central-header">
          <div class="central-header__title">
            <h3 class="font-normal" id="search-result-title">Search results for <strong>'{{request?.search_query}}'</strong></h3>
          </div>
        </header>
        <div class="central-filter central-filter--tabnav">
          <div class="central-filter__tabnav">
            <nav class="tab-nav tab-nav--tables">
              <div class="tab-nav__inner">
                <ul class="list-unstyled" id="search-nav">
                  <li [ngClass]="mode === 'Policies' ? 'is-active': null"><a href="javascript:;" (click)="changeMode('Policies')" data-category="policies">Policies ({{policyCount}})</a></li>
                  <li [ngClass]="mode === 'Quotes' ? 'is-active': null"><a href="javascript:;" (click)="changeMode('Quotes')"data-category="quotes">Quotes ({{quoteCount}})</a></li>
                  <li [ngClass]="mode === 'Claims' ? 'is-active': null"><a href="javascript:;" (click)="changeMode('Claims')"data-category="claims">Claims ({{claimCount}})</a></li>
                  <li [ngClass]="mode === 'Underwriting' ? 'is-active': null"><a href="javascript:;" (click)="changeMode('Underwriting')" data-category="underwriting">Underwriting ({{underwriterCount}})</a></li>
                </ul>
              </div>
            </nav>
            <!-- .tab-nav -->
          </div>
        </div>
       
        <div class="table__wrap table__wrap--broker table-responsive" id="table-wrap">
          <table datatable [dtOptions]="dtOptions" role="grid" [dtTrigger]="dtTrigger" class="table table--broker table--broker-quotes dataTable no-footer"
                 id="broker-table" style="width: 100% !important;">
            <thead>
            <tr role="row">
              <th class="cell-sticky cell-sticky--left" (click)="setOrder('name')" >
                Client
                <a href="javascript:;" class="table__sorter">
                  <svg class="icon">
                    <use xlink:href="#dropdown-up-smallest"></use>
                  </svg>
                </a>
              </th>
              <th class="sorting" (click)="setOrder(mode === 'Policies' || (uwView === 'Policies' && mode !== 'Quotes')  ?  (mode === 'Claims' ? 'claim_id' : 'policy_id') : 'policy_id')" 
                [attr.data-mobile-label]="mode === 'Policies' ? 'Policy No.' : 'Quote No.'">
                {{ mode === 'Policies' || (uwView === 'Policies' && mode !== 'Quotes')  ?  (mode === 'Claims' ? 'Claim No.' : 'Policy No.') : 'Quote No.'}}
                <a  href="javascript:;" class="table__sorter {{ order === 'asc' ? 'is-asc':'is-dsc'}}" data-toggle="sorter">
                  <svg class="icon">
                    <use xlink:href="#dropdown-up-smallest"></use>
                  </svg>
                </a>
              </th>
             
              <th class="sorting" (click)="setOrder(mode !== 'Claims' ? 'broker' : 'claim')"  [attr.data-mobile-label]="mode !== 'Claims' ? 'Broker' : 'Claim Name'">
                {{ mode !== 'Claims' ? 'Broker' : 'Claim Name'}}
                <a href="javascript:;" class="table__sorter {{ order === 'asc' ? 'is-asc':'is-dsc'}}" data-toggle="sorter">
                  <svg class="icon">
                    <use xlink:href="#dropdown-up-smallest"></use>
                  </svg>
                </a>
              </th>
              <th class="sorting" (click)="setOrder('category_name')" data-mobile-label="Product">
                Product
                <a  href="javascript:;" class="table__sorter {{ order === 'asc' ? 'is-asc':'is-dsc'}}" data-toggle="sorter">
                  <svg class="icon">
                    <use xlink:href="#dropdown-up-smallest"></use>
                  </svg>
                </a>
              </th>
              <th class="sorting" (click)="setOrder('policy_status')"  data-mobile-label="Status">
                Status
                <a  href="javascript:;" class="table__sorter {{ order === 'asc' ? 'is-asc':'is-dsc'}}" data-toggle="sorter">
                  <svg class="icon">
                    <use xlink:href="#dropdown-up-smallest"></use>
                  </svg>
                </a>
              </th>
             
              <th  class="sorting" (click)="setOrder('uw_score')"  data-mobile-label="UW" class="sorting" tabindex="0" aria-controls="broker-table" rowspan="1"
                  colspan="1" aria-label="UW: activate to sort column ascending" [style]="mode === 'Claims' ? 'display: none' : 'width:21px;'">
                UW 
                <a  href="javascript:;" class="table__sorter {{ order === 'asc' ? 'is-asc':'is-dsc'}}" data-toggle="sorter">
                  <svg class="icon">
                    <use xlink:href="#dropdown-up-smallest"></use>
                  </svg>
                </a>
              </th>
              <th [attr.data-mobile-label]="mode === 'Claims' ? 'Claim Date' : mode === 'Quotes' ? 'Quote Date' : 'Inception Date' " (click)="setOrder('date_inception')" >
                {{ mode === 'Claims' ? 'Claim Date' : mode === 'Quotes' ? 'Quote Date' : uwView !== 'Policies' ? 'Quote Date' : 'Inception Date' }}
               <a  href="javascript:;" class="table__sorter {{ order === 'asc' ? 'is-asc':'is-dsc'}}" data-toggle="sorter">
                <svg class="icon">
                  <use xlink:href="#dropdown-up-smallest"></use>
                </svg>
              </a>
              </th>
              <th [style]="mode === 'Claims' ? 'display: none' : null" class="cell-premium text-right" (click)="setOrder('prem_value')" data-mobile-label="Premium Total " class="text-right">
                Premium Total
                <a  href="javascript:;" class="table__sorter {{ order === 'asc' ? 'is-asc':'is-dsc'}}" data-toggle="sorter">
                  <svg class="icon">
                    <use xlink:href="#dropdown-up-smallest"></use>
                  </svg>
                </a>
              </th>
              <th class="cell-sticky cell-sticky--right cell-sticky--actions">&nbsp;</th>
              <th class="cell-sticky">&nbsp;</th>
            </tr>
            </thead>

            <tbody id="table-content">
              <tr *ngIf="isEmpty">
                <td colspan="10">
                  <div class="table-noresults__content">
                    <img src="assets/0/img/home/unsure.svg" alt="" class="img-fluid">
                    <h3 class="font-normal">No results found</h3>
                    <p>Try adjusting your search to find what you’re looking for.</p>
                  </div>
                </td>
              </tr>
            <tr *ngFor="let policy of policies;" >
              <td *ngIf="policy?.category_id !== 1" (click)="goTo(policy, $event)" class="cell-sticky cell-sticky--left"><strong>{{policy.person[0]?.first_name}} {{policy.person[0]?.last_name}}</strong></td>
              <td *ngIf="policy?.category_id === 1" (click)="goTo(policy, $event)" class="cell-sticky cell-sticky--left"><strong>{{policy?.company_name}}</strong></td>
              <td (click)="goTo(policy, $event)">{{policy.policy_id}}/{{policy?.version_id}}</td>
              <td *ngIf="mode === 'Claims' " (click)="goTo(policy, $event)">{{policy?.claim_name}}</td>
              <td *ngIf="mode !== 'Claims' " data-id="broker">{{policy?.broker_user}}</td>
              <td (click)="goTo(policy, $event)">
                <img src="assets/{{policy.product_category_id}}/favicon/favicon.svg" class="icon icon--sm mr-10"
                     alt=""/>
                <strong>{{policy.category_name}}</strong>
              </td>
              <td>
                <span
                  class="tag-pill"
                  [ngClass]="{
                  'tag-pill--active': policy.policy_status === 'Active' || policy.policy_status === 'Claim Registered' || policy.policy_status === 'Converted',
                  'tag-pill--paused': policy.policy_status === 'Paused' || policy.policy_status === 'In Progress' || policy.policy_status === 'Rejected',
                  'tag-pill--inactive': policy.policy_status === 'Cancelled' || policy.policy_status === 'Expired' || policy.policy_status === 'Suspended' || policy.policy_status === 'Removed' || policy.policy_status === 'Revoked'
                  }">
                  {{policy?.policy_status}}
                </span>
              </td>
              <td [style]="mode === 'Claims' ? 'display: none' : null">
                <span (click)="postSignup(policy)"
                  *ngIf="policy.uw_score > 0"
                  class="tag-pill"
                  [ngClass]="{
                  'tag-pill--status-amber': policy.uw_score === 1 || policy.uw_score === 2,
                  'tag-pill--status-red': policy.uw_score === 3,
                  'tag-pill--status-green': policy.uw_score > 3
                  }">
                  {{policy.uw_score}}
                </span>
              </td>
              <td>{{policy.date_inception | date: 'yyyy-MM-dd'}}</td>
              <td [style]="mode === 'Claims' ? 'display: none' : null" class="text-right"><strong>{{policy?.currency}} {{accounting.formatNumber(policy.prem_value)}}</strong>/{{policy?.frequency_short}}</td>
              <td class="has-action text-right cell-sticky cell-sticky--right cell-sticky--actions">
              </td>
              <td class="has-action cell-min cell-sticky">
                <div  class="dropdown">
                  <a href="javascript:void(0);"
                     class="dropdown-toggle dropdown-toggle--central dropdown-toggle--nocaret d-none d-md-block"
                     data-toggle="dropdown">
                    <svg class="icon">
                      <use xlink:href="#more"></use>
                    </svg>
                  </a>
                  <a href="#modal-traymenu-actions"
                     class="dropdown-toggle dropdown-toggle--central dropdown-toggle--nocaret d-md-none"
                     data-toggle="modal">
                    <svg class="icon">
                      <use xlink:href="#more"></use>
                    </svg>
                  </a>
                  <div *ngIf="person?.underwriter" class="dropdown-menu dropdown-menu-right dropdown-menu--central">
                    <a (click)="goTo(policy, $event)" class="dropdown-item" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#info"></use>
                      </svg>
                      <span>View Policy</span>
                    </a>
                    <a class="dropdown-item" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#info"></use>
                      </svg>
                      <span>Notify Client</span>
                    </a>

                  </div>
                  <div *ngIf="!person?.underwriter"
                       class="dropdown-menu dropdown-menu-right dropdown-menu--central">
                    <a *ngIf="mode !== 'Claims' && policy.policy_status === 'Active'" href="javascript:void(0);" class="dropdown-item" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#info"></use>
                      </svg>
                      <span>Contact Client</span>
                    </a>
                    <a *ngIf="mode !== 'Claims' && policy.policy_status === 'Active' " class="dropdown-item" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#info"></use>
                      </svg>
                      <span>Contact Underwriter</span>
                    </a>
                    <a *ngIf="mode === 'Quotes'" (click)="downloadQuoteSchedule(policy)" class="dropdown-item" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#download"></use>
                      </svg>
                      <span>Download Quote Schedule</span>
                    </a>
                    <a *ngIf="mode === 'Quotes'" (click)="viewTranscript(policy)" class="dropdown-item" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#download"></use>
                      </svg>
                      <span>View Transcript</span>
                    </a>
                    <a *ngIf="mode === 'Quotes' && policy.policy_status === 'Active'" (click)="resendQuoteLink(policy)" class="dropdown-item" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#info"></use>
                      </svg>
                      <span>Resend Quote Link</span>
                    </a>
                    <a *ngIf="mode === 'Policies'" href="javascript:;" (click)="startClaim(policy)" class="dropdown-item">
                      <svg class="icon"><use xlink:href="#add-items"></use></svg>
                      <span>Add Claim</span>
                    </a>
                    <a *ngIf="mode === 'Claims'" href="javascript:;" (click)="goTo(policy, $event)" class="dropdown-item">
                      <svg class="icon"><use xlink:href="#edit"></use></svg>
                      <span>Edit Claim</span>
                    </a>
                    <a *ngIf="mode === 'Claims'" href="javascript:;" (click)="removeClaim(policy?.policy_id)" class="dropdown-item">
                      <svg class="icon"><use xlink:href="#trash-bin"></use></svg>
                      <span>Remove Claim</span>
                    </a>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
       
      </div>
    </div>
  </div>
</main>

<app-emergency-services-modal [active]="true" #emergencyServicesModalComponent></app-emergency-services-modal>

<app-disclaimer></app-disclaimer>

<div class="modal fade modal--alert" id="view-modal" tabindex="-1" role="dialog"
     aria-labelledby="pause-summary-modal" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/0/avatar/happy.png" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h4>Which view would you like to use?</h4>
          </div>
        </div>
      </div>
      <div class="modal-alert__button">
        <div class="container">
          <a href="javascript:void(0);" routerLink="/everything.policy-overview" id="pause-summary-no"
             class="button button--lg button--primary" data-dismiss="modal">Broker</a>

          <a href="javascript:void(0);" routerLink="/everything.underwriter-landing" id="pause-summary-no"
             class="button button--lg button--secondary" data-dismiss="modal">Underwriter</a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade modal--note" id="modal-notes-notify" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content modal-note">
      <div class="modal-note__heading">
        <div class="container">
          <h5>Notes</h5>
          <button class="modal-note__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-note__content">
        <div class="container">
          <div class="notetree">
            <div class="notetree__item">
              <div class="notetree__item-branch">
                <svg class="icon">
                  <use xlink:href="#note-filled"></use>
                </svg>
              </div>
              <div class="notetree__item-content">
                <div class="notetree__item-title">
                  <h5>Lia Bhardvaj</h5>
                  <time>July 23, 2020</time>
                </div>
                <div class="rte">
                  <p>[Message from UW to Broker: Vestibulum pellentesque ex tortor, pellentesque lacinia elit efficitur
                    in. Ut dignissim ac justo at aliquam. Donec et commodo nulla. Proin quis ex ac ligula laoreet.]</p>
                </div>
                <div class="tag-pill__list mt-10">
                  <a href="javascript:void(0);" class="tag-pill tag-pill--file">
                    <svg class="icon">
                      <use xlink:href="#attachment"></use>
                    </svg>
                    [filename].pdf</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- mobile menu modal -->
<div class="modal fade modal--fullscreen" id="mobile-quote-menu" tabindex="-1" role="dialog"
     aria-labelledby="mobile-quote-menu" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-everything">
      <div class="modal-everything__header">
        <div class="container">
          <div class="modal-everything__title">
            Our Products
          </div>
          <button type="button" data-dismiss="modal" aria-label="Close" class="modal-everything__close">
            <svg class="icon">
              <use xlink:href="#close-circle-small"></use>
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-everything__content">
        <div class="container">
          <ul class="everything-categories-mobile list-unstyled">
            <li>
              <a href="javascript:void(0);" class="everything-categories-mobile__item">
                <svg-icon src="assets/1/logo.svg" alt="Business.Insure" class="img-fluid fill-business" [applyClass]="true"></svg-icon>
              </a>
            </li>
            <li>
              <a href="javascript:void(0);" class="everything-categories-mobile__item">
                <svg-icon src="assets/4/logo.svg" alt="Life.Insure" class="img-fluid fill-lifestyle" [applyClass]="true"></svg-icon>
              </a>
            </li>
            <li>
              <a href="javascript:void(0);" class="everything-categories-mobile__item">
                <svg-icon src="assets/3/logo.svg" alt="Personal.Insure" class="img-fluid fill-personal" [applyClass]="true"></svg-icon>
              </a>
            </li>
            <li>
              <a href="javascript:void(0);" class="everything-categories-mobile__item">
                <svg-icon src="assets/2/logo.svg" alt="Professional.Insure" class="img-fluid fill-professional" [applyClass]="true"></svg-icon>
              </a>
            </li>
            <li>
              <a href="javascript:void(0);" class="everything-categories-mobile__item">
                <svg-icon src="assets/5/logo.svg" alt="Tourism.Insure" class="img-fluid fill-tourism"></svg-icon>
              </a>
            </li>
            <li>
              <div class="everything-categories-mobile__item everything-categories-mobile__item--unsure">
                <p><strong>Unsure?</strong></p>
                <p><a href="javascript:void(0);"><strong>Let us help you</strong></a></p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="modal-everything__actions">
        <div class="container">
          <button class="button button--block button--secondary">Login</button>
          <button class="button button--block button--primary-gradient">Get a Quote</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- /modal -->
<!-- help modal -->
<div class="modal fade modal--max" id="help-modal" tabindex="-1" role="dialog" aria-labelledby="help-modal"
     aria-hidden="true">
  <div class="modal-dialog modal-help" role="document">
    <div class="modal-content modal-help__inner">
      <header class="modal-help__header">
        <a href="javascript:void(0);" class="modal-help__back">
          <svg class="icon">
            <use xlink:href="#arrow-left-small"></use>
          </svg>
          <span>Back</span>
        </a>
        <a href="javascript:void(0);" class="modal-help__close" data-dismiss="modal">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
        </a>
      </header>
      <div class="modal-help__content">
        <div class="container">

          <div class="modal-help__title">
            <h2 class="font-serif">What do you want to insure?</h2>
          </div>


          <div class="modal-help__categories is-active">
            <p>Our products extend to every facet of life, from personal home and car, to business assets, professional
              indemnity, to death and disability cover as well as travel insurance. Whatever your insurance needs, we’ve
              got you covered.</p>

            <!-- add everything-categories--extended for max 4 products per row -->
            <ul class="everything-categories list-unstyled">
              <li>
                <a href="javascript:void(0);" class="everything-categories__item">
                  <svg-icon src="assets/1/logo.svg" alt="Business.Insure" class="img-fluid fill-business" [applyClass]="true"></svg-icon>
                  <div class="everything-categories__item-content">
                    <p>Everything you own in a business from assets to liability cover.</p>
                  </div>
                  <div class="everything-categories__item-btn text-color-business">
                    <span>Get a Quote</span>
                    <svg class="icon">
                      <use xlink:href="#arrow-right"></use>
                    </svg>
                  </div>
                  <div class="everything-categories__item-indi bg-color-business"></div>
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" class="everything-categories__item">
                  <svg-icon src="assets/4/logo.svg" alt="Life.Insure" class="img-fluid fill-lifestyle" [applyClass]="true"></svg-icon>
                  <div class="everything-categories__item-content">
                    <p>Everything to do with your general life and risks you face. </p>
                  </div>
                  <div class="everything-categories__item-btn text-color-life">
                    <span>Get a Quote</span>
                    <svg class="icon">
                      <use xlink:href="#arrow-right"></use>
                    </svg>
                  </div>
                  <div class="everything-categories__item-indi bg-color-life"></div>
                </a>
              </li>
              <li>
                <a href="#product-personal" data-product="true" class="everything-categories__item">
                  <svg-icon src="assets/3/logo.svg" alt="Personal.Insure" class="img-fluid fill-personal" [applyClass]="true"></svg-icon>
                  <div class="everything-categories__item-content">
                    <p>Everything you care about and own in your personal capacity.</p>
                  </div>
                  <div class="everything-categories__item-btn text-color-personal">
                    <span>Get Started</span>
                    <svg class="icon">
                      <use xlink:href="#arrow-right"></use>
                    </svg>
                  </div>
                  <div class="everything-categories__item-indi bg-color-personal"></div>
                </a>
              </li>
              <li>
                <a href="#product-professional" data-product="true" class="everything-categories__item">
                  <svg-icon src="assets/2/logo.svg" alt="Professional.Insure" class="img-fluid fill-professional" [applyClass]="true"></svg-icon>
                  <div class="everything-categories__item-content">
                    <p>Everything to insure you as a professional in the event that you get sued.</p>
                  </div>
                  <div class="everything-categories__item-btn text-color-professional">
                    <span>Get Started</span>
                    <svg class="icon">
                      <use xlink:href="#arrow-right"></use>
                    </svg>
                  </div>
                  <div class="everything-categories__item-indi bg-color-professional"></div>
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" class="everything-categories__item">
                  <svg-icon src="assets/5/logo.svg" alt="Tourism.Insure" class="img-fluid fill-tourism" [applyClass]="true"></svg-icon>
                  <div class="everything-categories__item-content">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                  </div>
                  <div class="everything-categories__item-btn text-color-professional">
                    <span>Get a Quote</span>
                    <svg class="icon">
                      <use xlink:href="#arrow-right"></use>
                    </svg>
                  </div>
                  <div class="everything-categories__item-indi bg-color-professional"></div>
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" class="everything-categories__item everything-categories__item--unsure">
                  <img src="assets/0/img/home/unsure.svg" alt="" class="img-fluid">
                  <p><strong>Unsure what insurance you need?</strong></p>
                  <p><span class="link"><strong>Let us help you</strong></span></p>
                </a>
              </li>
            </ul>

          </div>

          <div class="modal-help__products">
            <ul class="everything-products everything-products--personal list-unstyled" id="product-personal">
              <li>
                <div class="everything-products__copy">
                  <h4>Comprehensive Professional Liability</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pellen tesque vitae justo non
                    sodales. Phasellus in justo ut risus congue volutpat.</p>
                </div>
                <a href="javascript:void(0);" class="button button--personal-gradient">Get a Quote</a>
              </li>
              <li>
                <div class="everything-products__copy">
                  <h4>Medical Malpractice</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pellen tesque vitae justo non
                    sodales. Phasellus in justo ut risus congue volutpat.</p>
                </div>
                <a href="javascript:void(0);" class="button button--personal-gradient">Get a Quote</a>
              </li>
              <li>
                <div class="everything-products__copy">
                  <h4>Tradesman</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pellen tesque vitae justo non
                    sodales. Phasellus in justo ut risus congue volutpat.</p>
                </div>
                <a href="javascript:void(0);" class="button button--personal-gradient">Get a Quote</a>
              </li>
            </ul>
            <ul class="everything-products everything-products--professional list-unstyled" id="product-professional">
              <li>
                <div class="everything-products__copy">
                  <h4>Comprehensive Professional Liability</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pellen tesque vitae justo non
                    sodales. Phasellus in justo ut risus congue volutpat.</p>
                </div>
                <a href="javascript:void(0);" class="button button--professional-gradient">Get a Quote</a>
              </li>
              <li>
                <div class="everything-products__copy">
                  <h4>Medical Malpractice</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pellen tesque vitae justo non
                    sodales. Phasellus in justo ut risus congue volutpat.</p>
                </div>
                <a href="javascript:void(0);" class="button button--professional-gradient">Get a Quote</a>
              </li>
              <li>
                <div class="everything-products__copy">
                  <h4>Tradesman</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pellen tesque vitae justo non
                    sodales. Phasellus in justo ut risus congue volutpat.</p>
                </div>
                <a href="javascript:void(0);" class="button button--professional-gradient">Get a Quote</a>
              </li>
              <li>
                <div class="everything-products__copy">
                  <h4>SME Professional Liability</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pellen tesque vitae justo non
                    sodales. Phasellus in justo ut risus congue volutpat.</p>
                </div>
                <a href="javascript:void(0);" class="button button--professional-gradient">Get a Quote</a>
              </li>
            </ul>
          </div>

        </div>
      </div>


    </div>
  </div>
</div>
<!-- /modal -->
<!-- tray menu modal (mobile only) -->
<div class="modal fade modal--tray" id="modal-traymenu-actions" tabindex="-1" role="dialog"
     aria-labelledby="modal-traymenu-more" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content modal-traymenu">
      <div class="container">
        <div class="modal-traymenu__list list-unstyled">
          <a href="javascript:void(0);" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#info"></use>
            </svg>
            <div>Contact Client</div>
          </a>
          <a href="#modal-contact-uw" data-toggle="modal" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#info"></use>
            </svg>
            <div>Contact Underwriter</div>
          </a>
        </div>

        <a href="javascript:void(0);" data-dismiss="modal" class="modal-traymenu__close">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
          <div>Close</div>
        </a>
      </div>
    </div>
  </div>
</div>
<!-- /modal -->

<!-- tray menu modal (mobile only) -->
<div class="modal fade modal--tray" id="modal-traymenu-filters" tabindex="-1" role="dialog"
     aria-labelledby="modal-traymenu-filters" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content modal-traymenu modal-traymenu--fs">

      <div class="modal-traymenu__header">
        <div class="container">
          <h6>Filters ({{policies?.length}})</h6>
          <a href="javascript:void(0);" class="modal-traymenu__header-clear" id="clear-mobile-filters">Clear</a>
          <a href="javascript:void(0);" data-dismiss="modal" class="modal-traymenu__header-close">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </a>
        </div>
      </div>

      <div class="modal-traymenu__filters">
        <div class="container">

          <div class="filter-list__heading">Products</div>
          <ul class="filter-list filter-list--central list-unstyled" id="mobile-products-filter-list">
            <li>
              <label class="custom-input custom-input--checkbox">
                <input type="checkbox" (click)="onProductFilterChange('all')" value="all" [checked]="checkIfAllProductsChecked()"
                  name="product-filter[]">
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">All</span>
              </label>
            </li>
            <li *ngFor="let category of categories">
              <label class="custom-input custom-input--checkbox">
                <input
                  type="checkbox"
                  (click)="onProductFilterChange(category?.product_category_id)"
                  [checked]="product_ids?.includes(category?.product_category_id)"
                  [value]="category?.product_category_id" name="product-filter[]">
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">{{category.category_name }}</span>
              </label>
            </li>
           
          </ul>

          <div class="filter-list__heading">Status</div>
          <ul class="filter-list filter-list--central list-unstyled" id="mobile-status-filter-list">
            <li>
              <label class="custom-input custom-input--checkbox">
                <input type="checkbox" 
                [checked]="" 
                (change)="onStatusFilterChange('all')"
                name="mobile-status-filter[]"/>
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">All</span>
              </label>
            </li>
            <ng-container *ngIf="mode === 'Policies' ">
            <li *ngFor="let status of statuses">
              <label class="custom-input custom-input--checkbox">
                <input type="checkbox" 
                value="status?.policy_status_id"
                [checked]="status_ids.includes(status?.policy_status_id)"
                (change)="onStatusFilterChange(status?.policy_status_id)"
                name="mobile-status-filter[]"/>
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">{{status?.policy_status}}</span>
              </label>
            </li>
          </ng-container>
          <ng-container *ngIf="mode !== 'Policies' ">
            <li *ngFor="let status of statuses">
              <label class="custom-input custom-input--checkbox">
                <input type="checkbox" 
                value="status?.quote_status_id"
                [checked]="status_ids.includes(status?.quote_status_id)"
                (change)="onStatusFilterChange(status?.quote_status_id)"
                name="mobile-status-filter[]"/>
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">{{status?.quote_status}}</span>
              </label>
            </li>
          </ng-container>
       
          </ul>

          <div class="filter-list__heading">Premium Order</div>
          <ul class="filter-list filter-list--central list-unstyled" id="mobile-relevance-filter-list">
            <li>
              <label class="custom-input custom-input--radio">
                <input type="radio" checked="" value="high-low" name="mobile-premium-filter[]"/>
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">Premium High to Low</span>
              </label>
            </li>
            <li>
              <label class="custom-input custom-input--radio">
                <input type="radio" value="low-high" name="mobile-premium-filter[]"/>
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">Premium Low to High</span>
              </label>
            </li>
          </ul>

          <!-- <div class="filter-list__heading">Relevance</div>
          <ul class="filter-list filter-list--central list-unstyled" id="mobile-relevance-filter-list">
            <li>
              <label class="custom-input custom-input--radio">
                <input type="radio" checked="" value="me" name="mobile-relevance-filter[]"/>
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">Relevant to me</span>
              </label>
            </li>
            <li>
              <label class="custom-input custom-input--radio">
                <input type="radio" value="all" name="mobile-relevance-filter[]"/>
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">All users</span>
              </label>
            </li>
          </ul> -->
        </div>
      </div>

      <div class="modal-traymenu__btn">
        <div class="container">
          <a href="javascript:void(0);" data-dismiss="modal" class="button button--primary button--block"
             id="mobile-filter-apply" (click)="applyFilters()">Apply</a>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- /modal -->
<!-- /modal -->


<div class="modal fade modal--alert" id="error-modal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="error-modal"
     aria-modal="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--prorata">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img [src]="'assets/0/avatar/sad.png'" alt=""
                 class="img-fluid">
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-circle-small"></use>
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h4>Oops!</h4>
            <p class="error-text"></p>
          </div>
        </div>
      </div>
      <div class="modal-alert__button">
        <div class="container">
          <a href="javascript:;" class="button button--lg button--primary" data-dismiss="modal">OK</a>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal modal--max modal--widest fade " id="advanced-search-modal" tabindex="-1" role="dialog" aria-labelledby="advanced-search-modal"  aria-modal="true">
  <div class="modal-dialog" role="document">
    <form class="modal-content modal-filter" id="advanced-search-form">

      <div class="modal-filter__title">
        Advanced search
        <a href="#" class="modal-filter__close" data-dismiss="modal">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
        </a>
      </div>

      <div class="modal-filter__content">
        <div class="modal-filter__content-inner">

            <div class="advanced-search-group">
              <div class="advanced-search-group__label advanced-search-group__label--center">Keyword</div>
              <div class="advanced-search-group__fields">
                <input type="text" class="form-control" id="advanced-search-keyword">
              </div>
            </div>

            <div class="advanced-search-group">
              <div class="advanced-search-group__label">Status</div>
              <div class="advanced-search-group__fields">

                <div class="advanced-search-group__status" id="advanced-search-status-group">

                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" name="search-status-active" value="active">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Active</span>
                  </label>

                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" name="search-status-approved" value="approved">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Approved</span>
                  </label>

                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" name="search-status-progress" value="in%20progress">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">In Progress</span>
                  </label>

                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" name="search-status-notification" value="received%20notification">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Received Notification</span>
                  </label>

                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" name="search-status-renewal" value="renewal%20due">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Renewal Due</span>
                  </label>

                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" name="search-status-declined" value="request%20declined">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Request Declined</span>
                  </label>

                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" name="search-status-underwriting" value="underwriting">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Underwriting</span>
                  </label>

                </div>


              </div>
            </div>

            <div class="advanced-search-group">
              <div class="advanced-search-group__label advanced-search-group__label--center">Date Range</div>
              <div class="advanced-search-group__fields">

                <div class="form-group mb-0">
                  <div class="form-group__daterange">
                    <div class="form-group__daterange-start">
                      <div class="form-group form-group--sm mb-0">
                        <div class="ui-datepicker__wrap">
                          <div class="form-control__wrap has-icon">
                            <input type="text" class="form-control hasDatepicker" value="" placeholder="From date" id="search-date-start" readonly=""><button type="button" class="ui-datepicker-trigger"></button>
                            <span class="form-control__icon"><svg class="icon">
                                <use xlink:href="#calendar"></use>
                              </svg></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group__daterange-to">
                      to
                    </div>
                    <div class="form-group__daterange-end">
                      <div class="form-group form-group--sm mb-0">
                        <div class="ui-datepicker__wrap">
                          <div class="form-control__wrap has-icon">
                            <input type="text" class="form-control hasDatepicker" value="" placeholder="To date" id="search-date-end" readonly=""><button type="button" class="ui-datepicker-trigger"></button>
                            <span class="form-control__icon"><svg class="icon">
                                <use xlink:href="#calendar"></use>
                              </svg></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>

        



        </div>
      </div>

      <div class="modal-filter__btn">
        <a href="#" disabled="disabled" class="button button--naked button--no-min" id="advanced-search-clear">Reset</a>
        <a href="everything.b2b-dashboard-tables-result.html" disabled="disabled" class="button button--primary" id="advanced-search-submit">Search</a>
      </div>

    </form>
  </div>
</div>
